/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddCommentRequest } from '../model';
// @ts-ignore
import type { Comment } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { HistoricalPolicyAcknowledgmentSorting } from '../model';
// @ts-ignore
import type { Log } from '../model';
// @ts-ignore
import type { PlatformFramework } from '../model';
// @ts-ignore
import type { Policy } from '../model';
// @ts-ignore
import type { PolicyAcknowledgmentExpandedPaginated } from '../model';
// @ts-ignore
import type { PolicyAcknowledgmentOverview } from '../model';
// @ts-ignore
import type { PolicyAcknowledgmentPaginated } from '../model';
// @ts-ignore
import type { PolicyAcknowledgmentProgressPaginated } from '../model';
// @ts-ignore
import type { PolicyAcknowledgmentStatus } from '../model';
// @ts-ignore
import type { PolicyCreate } from '../model';
// @ts-ignore
import type { PolicyExpandedSorting } from '../model';
// @ts-ignore
import type { PolicyOverviewPaginated } from '../model';
// @ts-ignore
import type { PolicyOwnerUpdate } from '../model';
// @ts-ignore
import type { PolicyPaginated } from '../model';
// @ts-ignore
import type { PolicySorting } from '../model';
// @ts-ignore
import type { PolicyStatus } from '../model';
// @ts-ignore
import type { PolicyStatusUpdate } from '../model';
// @ts-ignore
import type { PolicyTemplate } from '../model';
// @ts-ignore
import type { PolicyUserAcknowledgment } from '../model';
// @ts-ignore
import type { PolicyVersion } from '../model';
// @ts-ignore
import type { PolicyVersionCreate } from '../model';
// @ts-ignore
import type { PolicyVersionFrameworkUpdate } from '../model';
// @ts-ignore
import type { PolicyVersionFrameworksUpdate } from '../model';
// @ts-ignore
import type { PolicyVersionPaginated } from '../model';
// @ts-ignore
import type { PolicyVersionSorting } from '../model';
// @ts-ignore
import type { PolicyVersionStatus } from '../model';
// @ts-ignore
import type { PolicyVersionStatusUpdate } from '../model';
// @ts-ignore
import type { PolicyVersionUpdate } from '../model';
// @ts-ignore
import type { UserAcknowledgmentProgressPaginated } from '../model';
// @ts-ignore
import type { UserAcknowledgmentStatus } from '../model';
/**
 * PoliciesApi - axios parameter creator
 */
export const PoliciesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Record that the current user has acknowledged the policy\'s published version.
         * @summary Acknowledge Policy
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgePolicy: async (policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('acknowledgePolicy', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}/acknowledge`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add Framework to Policy Version
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {PolicyVersionFrameworkUpdate} policyVersionFrameworkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlatformFrameworkIntoPolicy: async (policyId: string, policyVersionId: string, policyVersionFrameworkUpdate: PolicyVersionFrameworkUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('addPlatformFrameworkIntoPolicy', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('addPlatformFrameworkIntoPolicy', 'policyVersionId', policyVersionId)
            // verify required parameter 'policyVersionFrameworkUpdate' is not null or undefined
            assertParamExists('addPlatformFrameworkIntoPolicy', 'policyVersionFrameworkUpdate', policyVersionFrameworkUpdate)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/platform-frameworks`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyVersionFrameworkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new policy for the organization
         * @summary Create Policy
         * @param {PolicyCreate} policyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicy: async (policyCreate: PolicyCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyCreate' is not null or undefined
            assertParamExists('createPolicy', 'policyCreate', policyCreate)
            const localVarPath = `/policies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Policy Comments
         * @param {string} policyId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyComments: async (policyId: string, addCommentRequest: AddCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('createPolicyComments', 'policyId', policyId)
            // verify required parameter 'addCommentRequest' is not null or undefined
            assertParamExists('createPolicyComments', 'addCommentRequest', addCommentRequest)
            const localVarPath = `/policies/{policy_id}/comments`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new version for an existing policy.
         * @summary Create Policy Version
         * @param {string} policyId 
         * @param {PolicyVersionCreate} policyVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyVersion: async (policyId: string, policyVersionCreate: PolicyVersionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('createPolicyVersion', 'policyId', policyId)
            // verify required parameter 'policyVersionCreate' is not null or undefined
            assertParamExists('createPolicyVersion', 'policyVersionCreate', policyVersionCreate)
            const localVarPath = `/policies/{policy_id}/versions`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyVersionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Policy Version Comments
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyVersionComments: async (policyId: string, policyVersionId: string, addCommentRequest: AddCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('createPolicyVersionComments', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('createPolicyVersionComments', 'policyVersionId', policyVersionId)
            // verify required parameter 'addCommentRequest' is not null or undefined
            assertParamExists('createPolicyVersionComments', 'addCommentRequest', addCommentRequest)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/comments`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the PDF attached to a draft policy version.
         * @summary Delete Policy Version PDF
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePolicyVersionContentFile: async (policyId: string, policyVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('deletePolicyVersionContentFile', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('deletePolicyVersionContentFile', 'policyVersionId', policyVersionId)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/content-file`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export the current display version of a policy as a PDF document.
         * @summary Export Policy PDF
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyVersionPdf: async (policyId: string, policyVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('exportPolicyVersionPdf', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('exportPolicyVersionPdf', 'policyVersionId', policyVersionId)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/export`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated acknowledgment progress for each published policy in the current organization.
         * @summary Get acknowledgment progress per policy
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {PolicyAcknowledgmentStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAcknowledgmentProgressPerPolicy: async (page?: number, size?: number, nameOrUniqueCode?: string | null, status?: PolicyAcknowledgmentStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policies/acknowledgments/per-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated historical policy acknowledgments for the current user.
         * @summary Get historical acknowledgments
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {HistoricalPolicyAcknowledgmentSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [policyNameOrUniqueCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricalAcknowledgments: async (page?: number, size?: number, sortBy?: HistoricalPolicyAcknowledgmentSorting | null, descending?: boolean | null, policyNameOrUniqueCode?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policies/historical-acknowledgments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (policyNameOrUniqueCode !== undefined) {
                localVarQueryParameter['policy_name_or_unique_code'] = policyNameOrUniqueCode;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a policy by id with its display version.
         * @summary Get Policy
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy: async (policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getPolicy', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get aggregated overview of policy acknowledgments for the current organization.
         * @summary Get acknowledgments overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyAcknowledgmentsOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policies/acknowledgments/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Policy Comments
         * @param {string} policyId 
         * @param {boolean} [excludePolicyVersions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyComments: async (policyId: string, excludePolicyVersions?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getPolicyComments', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}/comments`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (excludePolicyVersions !== undefined) {
                localVarQueryParameter['exclude_policy_versions'] = excludePolicyVersions;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a signed URL to preview the PDF attached to the current policy.
         * @summary Get Policy Current URL PDF
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyContentFile: async (policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getPolicyContentFile', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}/content-file`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get activity logs for a policy.
         * @summary Get Policy Logs
         * @param {string} policyId 
         * @param {boolean} [excludePolicyVersions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyLogs: async (policyId: string, excludePolicyVersions?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getPolicyLogs', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}/logs`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (excludePolicyVersions !== undefined) {
                localVarQueryParameter['exclude_policy_versions'] = excludePolicyVersions;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific policy version by policy_id and policy_version_id.
         * @summary Get Policy Version
         * @param {string} policyVersionId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersion: async (policyVersionId: string, policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('getPolicyVersion', 'policyVersionId', policyVersionId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getPolicyVersion', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}`
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)))
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Policy Version Comments
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersionComments: async (policyId: string, policyVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getPolicyVersionComments', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('getPolicyVersionComments', 'policyVersionId', policyVersionId)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/comments`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a signed URL to preview the PDF attached to a policy version.
         * @summary Get Policy Version URL PDF
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersionContentFile: async (policyId: string, policyVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getPolicyVersionContentFile', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('getPolicyVersionContentFile', 'policyVersionId', policyVersionId)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/content-file`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Policy Version Frameworks
         * @param {string} policyVersionId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersionFrameworks: async (policyVersionId: string, policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('getPolicyVersionFrameworks', 'policyVersionId', policyVersionId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getPolicyVersionFrameworks', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/platform-frameworks`
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)))
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get audit logs for a specific policy version.
         * @summary Get Policy Version Logs
         * @param {string} policyVersionId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersionLogs: async (policyVersionId: string, policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('getPolicyVersionLogs', 'policyVersionId', policyVersionId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getPolicyVersionLogs', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/logs`
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)))
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the template associated with the policy policy_template_version_id.
         * @summary Get Policy Template
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUsedByPolicy: async (policyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('getTemplateUsedByPolicy', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}/template`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated acknowledgment progress for each active user in the current organization.
         * @summary Get acknowledgment progress per user
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [nameOrEmail] 
         * @param {UserAcknowledgmentStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAcknowledgmentProgress: async (page?: number, size?: number, nameOrEmail?: string | null, status?: UserAcknowledgmentStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policies/acknowledgments/per-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (nameOrEmail !== undefined) {
                localVarQueryParameter['name_or_email'] = nameOrEmail;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query policies acknowledgments in the current organization. By default it filter acknowledgments of the latest published policies.
         * @summary Query acknowledgments
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [acknowledgedById] 
         * @param {string | null} [policyId] 
         * @param {string | null} [policyVersionId] 
         * @param {boolean} [includeHistoricAcknowledgments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryAcknowledgeablePolicies: async (page?: number, size?: number, acknowledgedById?: string | null, policyId?: string | null, policyVersionId?: string | null, includeHistoricAcknowledgments?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policies/acknowledgements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (acknowledgedById !== undefined) {
                localVarQueryParameter['acknowledged_by_id'] = acknowledgedById;
            }

            if (policyId !== undefined) {
                localVarQueryParameter['policy_id'] = policyId;
            }

            if (policyVersionId !== undefined) {
                localVarQueryParameter['policy_version_id'] = policyVersionId;
            }

            if (includeHistoricAcknowledgments !== undefined) {
                localVarQueryParameter['include_historic_acknowledgments'] = includeHistoricAcknowledgments;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query policies for the current organization. Non-policy-managers can only see published policies.
         * @summary Query Policies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicySorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {PolicyStatus | null} [status] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicies: async (page?: number, size?: number, sortBy?: PolicySorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, status?: PolicyStatus | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query policies with nested published and draft versions.
         * @summary Query Policies Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyExpandedSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [assignedToId] 
         * @param {PolicyVersionStatus | null} [draftPolicyVersionStatus] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {PolicyStatus | null} [status] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPoliciesExpanded: async (page?: number, size?: number, sortBy?: PolicyExpandedSorting | null, descending?: boolean | null, assignedToId?: string | null, draftPolicyVersionStatus?: PolicyVersionStatus | null, nameOrUniqueCode?: string | null, status?: PolicyStatus | null, exactMatch?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policies/expanded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (assignedToId !== undefined) {
                localVarQueryParameter['assigned_to_id'] = assignedToId;
            }

            if (draftPolicyVersionStatus !== undefined) {
                localVarQueryParameter['draft_policy_version_status'] = draftPolicyVersionStatus;
            }

            if (nameOrUniqueCode !== undefined) {
                localVarQueryParameter['name_or_unique_code'] = nameOrUniqueCode;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exact_match'] = exactMatch;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of published policies (latest version) with acknowledgment status for a user.
         * @summary Get policy acknowledgments expanded
         * @param {string} userId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [policyNameOrUniqueCode] 
         * @param {boolean | null} [isAcknowledged] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyAcknowledgmentsExpanded: async (userId: string, page?: number, size?: number, policyNameOrUniqueCode?: string | null, isAcknowledged?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('queryPolicyAcknowledgmentsExpanded', 'userId', userId)
            const localVarPath = `/policies/acknowledgments/expanded/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (policyNameOrUniqueCode !== undefined) {
                localVarQueryParameter['policy_name_or_unique_code'] = policyNameOrUniqueCode;
            }

            if (isAcknowledged !== undefined) {
                localVarQueryParameter['is_acknowledged'] = isAcknowledged;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query all versions of a specific policy.
         * @summary Query Policy Versions
         * @param {string} policyId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyVersionSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {PolicyVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyVersions: async (policyId: string, page?: number, size?: number, sortBy?: PolicyVersionSorting | null, descending?: boolean | null, name?: string | null, status?: PolicyVersionStatus | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('queryPolicyVersions', 'policyId', policyId)
            const localVarPath = `/policies/{policy_id}/versions`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Framework from Policy Version
         * @param {string} platformFrameworkId 
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePlatformFrameworkFromPolicy: async (platformFrameworkId: string, policyId: string, policyVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformFrameworkId' is not null or undefined
            assertParamExists('removePlatformFrameworkFromPolicy', 'platformFrameworkId', platformFrameworkId)
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('removePlatformFrameworkFromPolicy', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('removePlatformFrameworkFromPolicy', 'policyVersionId', policyVersionId)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/platform-frameworks/{platform_framework_id}`
                .replace('{platform_framework_id}', encodeURIComponent(String(platformFrameworkId)))
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace All Frameworks of Policy Version
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {PolicyVersionFrameworksUpdate} policyVersionFrameworksUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlatformFrameworksInPolicy: async (policyId: string, policyVersionId: string, policyVersionFrameworksUpdate: PolicyVersionFrameworksUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('updatePlatformFrameworksInPolicy', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('updatePlatformFrameworksInPolicy', 'policyVersionId', policyVersionId)
            // verify required parameter 'policyVersionFrameworksUpdate' is not null or undefined
            assertParamExists('updatePlatformFrameworksInPolicy', 'policyVersionFrameworksUpdate', policyVersionFrameworksUpdate)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/platform-frameworks`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyVersionFrameworksUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the owner of a policy.
         * @summary Update Policy Owner
         * @param {string} policyId 
         * @param {PolicyOwnerUpdate} policyOwnerUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyOwner: async (policyId: string, policyOwnerUpdate: PolicyOwnerUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('updatePolicyOwner', 'policyId', policyId)
            // verify required parameter 'policyOwnerUpdate' is not null or undefined
            assertParamExists('updatePolicyOwner', 'policyOwnerUpdate', policyOwnerUpdate)
            const localVarPath = `/policies/{policy_id}/owner`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyOwnerUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a policy.
         * @summary Update Policy Status
         * @param {string} policyId 
         * @param {PolicyStatusUpdate} policyStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyStatus: async (policyId: string, policyStatusUpdate: PolicyStatusUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('updatePolicyStatus', 'policyId', policyId)
            // verify required parameter 'policyStatusUpdate' is not null or undefined
            assertParamExists('updatePolicyStatus', 'policyStatusUpdate', policyStatusUpdate)
            const localVarPath = `/policies/{policy_id}/status`
                .replace('{policy_id}', encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit name and content of a policy version.
         * @summary Update Policy Version
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {PolicyVersionUpdate} policyVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyVersion: async (policyId: string, policyVersionId: string, policyVersionUpdate: PolicyVersionUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('updatePolicyVersion', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('updatePolicyVersion', 'policyVersionId', policyVersionId)
            // verify required parameter 'policyVersionUpdate' is not null or undefined
            assertParamExists('updatePolicyVersion', 'policyVersionUpdate', policyVersionUpdate)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyVersionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the status of a policy version.
         * @summary Update Policy Version Status
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {PolicyVersionStatusUpdate} policyVersionStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyVersionStatus: async (policyId: string, policyVersionId: string, policyVersionStatusUpdate: PolicyVersionStatusUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('updatePolicyVersionStatus', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('updatePolicyVersionStatus', 'policyVersionId', policyVersionId)
            // verify required parameter 'policyVersionStatusUpdate' is not null or undefined
            assertParamExists('updatePolicyVersionStatus', 'policyVersionStatusUpdate', policyVersionStatusUpdate)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/status`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyVersionStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a PDF file to an existing policy version. Replaces any previously attached file.
         * @summary Upload Policy Version PDF
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {File} contentFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPolicyVersionFile: async (policyId: string, policyVersionId: string, contentFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('uploadPolicyVersionFile', 'policyId', policyId)
            // verify required parameter 'policyVersionId' is not null or undefined
            assertParamExists('uploadPolicyVersionFile', 'policyVersionId', policyVersionId)
            // verify required parameter 'contentFile' is not null or undefined
            assertParamExists('uploadPolicyVersionFile', 'contentFile', contentFile)
            const localVarPath = `/policies/{policy_id}/versions/{policy_version_id}/content-file`
                .replace('{policy_id}', encodeURIComponent(String(policyId)))
                .replace('{policy_version_id}', encodeURIComponent(String(policyVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (contentFile !== undefined) { 
                localVarFormParams.append('content_file', contentFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoliciesApi - functional programming interface
 */
export const PoliciesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoliciesApiAxiosParamCreator(configuration)
    return {
        /**
         * Record that the current user has acknowledged the policy\'s published version.
         * @summary Acknowledge Policy
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acknowledgePolicy(policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyUserAcknowledgment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acknowledgePolicy(policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.acknowledgePolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add Framework to Policy Version
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {PolicyVersionFrameworkUpdate} policyVersionFrameworkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlatformFrameworkIntoPolicy(policyId: string, policyVersionId: string, policyVersionFrameworkUpdate: PolicyVersionFrameworkUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlatformFrameworkIntoPolicy(policyId, policyVersionId, policyVersionFrameworkUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.addPlatformFrameworkIntoPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new policy for the organization
         * @summary Create Policy
         * @param {PolicyCreate} policyCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPolicy(policyCreate: PolicyCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Policy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPolicy(policyCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.createPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Policy Comments
         * @param {string} policyId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPolicyComments(policyId: string, addCommentRequest: AddCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPolicyComments(policyId, addCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.createPolicyComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new version for an existing policy.
         * @summary Create Policy Version
         * @param {string} policyId 
         * @param {PolicyVersionCreate} policyVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPolicyVersion(policyId: string, policyVersionCreate: PolicyVersionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPolicyVersion(policyId, policyVersionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.createPolicyVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Policy Version Comments
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {AddCommentRequest} addCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPolicyVersionComments(policyId: string, policyVersionId: string, addCommentRequest: AddCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPolicyVersionComments(policyId, policyVersionId, addCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.createPolicyVersionComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete the PDF attached to a draft policy version.
         * @summary Delete Policy Version PDF
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePolicyVersionContentFile(policyId: string, policyVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePolicyVersionContentFile(policyId, policyVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.deletePolicyVersionContentFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export the current display version of a policy as a PDF document.
         * @summary Export Policy PDF
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPolicyVersionPdf(policyId: string, policyVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPolicyVersionPdf(policyId, policyVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.exportPolicyVersionPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated acknowledgment progress for each published policy in the current organization.
         * @summary Get acknowledgment progress per policy
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {PolicyAcknowledgmentStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAcknowledgmentProgressPerPolicy(page?: number, size?: number, nameOrUniqueCode?: string | null, status?: PolicyAcknowledgmentStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyAcknowledgmentProgressPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAcknowledgmentProgressPerPolicy(page, size, nameOrUniqueCode, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getAcknowledgmentProgressPerPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated historical policy acknowledgments for the current user.
         * @summary Get historical acknowledgments
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {HistoricalPolicyAcknowledgmentSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [policyNameOrUniqueCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoricalAcknowledgments(page?: number, size?: number, sortBy?: HistoricalPolicyAcknowledgmentSorting | null, descending?: boolean | null, policyNameOrUniqueCode?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyAcknowledgmentExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoricalAcknowledgments(page, size, sortBy, descending, policyNameOrUniqueCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getHistoricalAcknowledgments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a policy by id with its display version.
         * @summary Get Policy
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicy(policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Policy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicy(policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get aggregated overview of policy acknowledgments for the current organization.
         * @summary Get acknowledgments overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyAcknowledgmentsOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyAcknowledgmentOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyAcknowledgmentsOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicyAcknowledgmentsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Policy Comments
         * @param {string} policyId 
         * @param {boolean} [excludePolicyVersions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyComments(policyId: string, excludePolicyVersions?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyComments(policyId, excludePolicyVersions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicyComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a signed URL to preview the PDF attached to the current policy.
         * @summary Get Policy Current URL PDF
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyContentFile(policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string | null; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyContentFile(policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicyContentFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get activity logs for a policy.
         * @summary Get Policy Logs
         * @param {string} policyId 
         * @param {boolean} [excludePolicyVersions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyLogs(policyId: string, excludePolicyVersions?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Log>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyLogs(policyId, excludePolicyVersions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicyLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific policy version by policy_id and policy_version_id.
         * @summary Get Policy Version
         * @param {string} policyVersionId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyVersion(policyVersionId: string, policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyVersion(policyVersionId, policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicyVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Policy Version Comments
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyVersionComments(policyId: string, policyVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyVersionComments(policyId, policyVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicyVersionComments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a signed URL to preview the PDF attached to a policy version.
         * @summary Get Policy Version URL PDF
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyVersionContentFile(policyId: string, policyVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string | null; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyVersionContentFile(policyId, policyVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicyVersionContentFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Policy Version Frameworks
         * @param {string} policyVersionId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyVersionFrameworks(policyVersionId: string, policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlatformFramework>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyVersionFrameworks(policyVersionId, policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicyVersionFrameworks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get audit logs for a specific policy version.
         * @summary Get Policy Version Logs
         * @param {string} policyVersionId 
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyVersionLogs(policyVersionId: string, policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Log>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyVersionLogs(policyVersionId, policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getPolicyVersionLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the template associated with the policy policy_template_version_id.
         * @summary Get Policy Template
         * @param {string} policyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateUsedByPolicy(policyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateUsedByPolicy(policyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getTemplateUsedByPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated acknowledgment progress for each active user in the current organization.
         * @summary Get acknowledgment progress per user
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [nameOrEmail] 
         * @param {UserAcknowledgmentStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAcknowledgmentProgress(page?: number, size?: number, nameOrEmail?: string | null, status?: UserAcknowledgmentStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAcknowledgmentProgressPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAcknowledgmentProgress(page, size, nameOrEmail, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.getUserAcknowledgmentProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query policies acknowledgments in the current organization. By default it filter acknowledgments of the latest published policies.
         * @summary Query acknowledgments
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [acknowledgedById] 
         * @param {string | null} [policyId] 
         * @param {string | null} [policyVersionId] 
         * @param {boolean} [includeHistoricAcknowledgments] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryAcknowledgeablePolicies(page?: number, size?: number, acknowledgedById?: string | null, policyId?: string | null, policyVersionId?: string | null, includeHistoricAcknowledgments?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyAcknowledgmentPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryAcknowledgeablePolicies(page, size, acknowledgedById, policyId, policyVersionId, includeHistoricAcknowledgments, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.queryAcknowledgeablePolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query policies for the current organization. Non-policy-managers can only see published policies.
         * @summary Query Policies
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicySorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {PolicyStatus | null} [status] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryPolicies(page?: number, size?: number, sortBy?: PolicySorting | null, descending?: boolean | null, nameOrUniqueCode?: string | null, status?: PolicyStatus | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryPolicies(page, size, sortBy, descending, nameOrUniqueCode, status, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.queryPolicies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query policies with nested published and draft versions.
         * @summary Query Policies Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyExpandedSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [assignedToId] 
         * @param {PolicyVersionStatus | null} [draftPolicyVersionStatus] 
         * @param {string | null} [nameOrUniqueCode] 
         * @param {PolicyStatus | null} [status] 
         * @param {boolean} [exactMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryPoliciesExpanded(page?: number, size?: number, sortBy?: PolicyExpandedSorting | null, descending?: boolean | null, assignedToId?: string | null, draftPolicyVersionStatus?: PolicyVersionStatus | null, nameOrUniqueCode?: string | null, status?: PolicyStatus | null, exactMatch?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyOverviewPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryPoliciesExpanded(page, size, sortBy, descending, assignedToId, draftPolicyVersionStatus, nameOrUniqueCode, status, exactMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.queryPoliciesExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of published policies (latest version) with acknowledgment status for a user.
         * @summary Get policy acknowledgments expanded
         * @param {string} userId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string | null} [policyNameOrUniqueCode] 
         * @param {boolean | null} [isAcknowledged] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryPolicyAcknowledgmentsExpanded(userId: string, page?: number, size?: number, policyNameOrUniqueCode?: string | null, isAcknowledged?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyAcknowledgmentExpandedPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryPolicyAcknowledgmentsExpanded(userId, page, size, policyNameOrUniqueCode, isAcknowledged, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.queryPolicyAcknowledgmentsExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query all versions of a specific policy.
         * @summary Query Policy Versions
         * @param {string} policyId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyVersionSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [name] 
         * @param {PolicyVersionStatus | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryPolicyVersions(policyId: string, page?: number, size?: number, sortBy?: PolicyVersionSorting | null, descending?: boolean | null, name?: string | null, status?: PolicyVersionStatus | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyVersionPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryPolicyVersions(policyId, page, size, sortBy, descending, name, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.queryPolicyVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Framework from Policy Version
         * @param {string} platformFrameworkId 
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePlatformFrameworkFromPolicy(platformFrameworkId: string, policyId: string, policyVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePlatformFrameworkFromPolicy(platformFrameworkId, policyId, policyVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.removePlatformFrameworkFromPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace All Frameworks of Policy Version
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {PolicyVersionFrameworksUpdate} policyVersionFrameworksUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlatformFrameworksInPolicy(policyId: string, policyVersionId: string, policyVersionFrameworksUpdate: PolicyVersionFrameworksUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlatformFrameworksInPolicy(policyId, policyVersionId, policyVersionFrameworksUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.updatePlatformFrameworksInPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the owner of a policy.
         * @summary Update Policy Owner
         * @param {string} policyId 
         * @param {PolicyOwnerUpdate} policyOwnerUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePolicyOwner(policyId: string, policyOwnerUpdate: PolicyOwnerUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Policy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePolicyOwner(policyId, policyOwnerUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.updatePolicyOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a policy.
         * @summary Update Policy Status
         * @param {string} policyId 
         * @param {PolicyStatusUpdate} policyStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePolicyStatus(policyId: string, policyStatusUpdate: PolicyStatusUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Policy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePolicyStatus(policyId, policyStatusUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.updatePolicyStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit name and content of a policy version.
         * @summary Update Policy Version
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {PolicyVersionUpdate} policyVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePolicyVersion(policyId: string, policyVersionId: string, policyVersionUpdate: PolicyVersionUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePolicyVersion(policyId, policyVersionId, policyVersionUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.updatePolicyVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the status of a policy version.
         * @summary Update Policy Version Status
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {PolicyVersionStatusUpdate} policyVersionStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePolicyVersionStatus(policyId: string, policyVersionId: string, policyVersionStatusUpdate: PolicyVersionStatusUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePolicyVersionStatus(policyId, policyVersionId, policyVersionStatusUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.updatePolicyVersionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a PDF file to an existing policy version. Replaces any previously attached file.
         * @summary Upload Policy Version PDF
         * @param {string} policyId 
         * @param {string} policyVersionId 
         * @param {File} contentFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPolicyVersionFile(policyId: string, policyVersionId: string, contentFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPolicyVersionFile(policyId, policyVersionId, contentFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoliciesApi.uploadPolicyVersionFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PoliciesApi - factory interface
 */
export const PoliciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoliciesApiFp(configuration)
    return {
        /**
         * Record that the current user has acknowledged the policy\'s published version.
         * @summary Acknowledge Policy
         * @param {PoliciesApiAcknowledgePolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgePolicy(requestParameters: PoliciesApiAcknowledgePolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyUserAcknowledgment> {
            return localVarFp.acknowledgePolicy(requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add Framework to Policy Version
         * @param {PoliciesApiAddPlatformFrameworkIntoPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlatformFrameworkIntoPolicy(requestParameters: PoliciesApiAddPlatformFrameworkIntoPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyVersion> {
            return localVarFp.addPlatformFrameworkIntoPolicy(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.policyVersionFrameworkUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new policy for the organization
         * @summary Create Policy
         * @param {PoliciesApiCreatePolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicy(requestParameters: PoliciesApiCreatePolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Policy> {
            return localVarFp.createPolicy(requestParameters.policyCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Policy Comments
         * @param {PoliciesApiCreatePolicyCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyComments(requestParameters: PoliciesApiCreatePolicyCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Comment> {
            return localVarFp.createPolicyComments(requestParameters.policyId, requestParameters.addCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new version for an existing policy.
         * @summary Create Policy Version
         * @param {PoliciesApiCreatePolicyVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyVersion(requestParameters: PoliciesApiCreatePolicyVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyVersion> {
            return localVarFp.createPolicyVersion(requestParameters.policyId, requestParameters.policyVersionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Policy Version Comments
         * @param {PoliciesApiCreatePolicyVersionCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyVersionComments(requestParameters: PoliciesApiCreatePolicyVersionCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Comment> {
            return localVarFp.createPolicyVersionComments(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.addCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the PDF attached to a draft policy version.
         * @summary Delete Policy Version PDF
         * @param {PoliciesApiDeletePolicyVersionContentFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePolicyVersionContentFile(requestParameters: PoliciesApiDeletePolicyVersionContentFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePolicyVersionContentFile(requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export the current display version of a policy as a PDF document.
         * @summary Export Policy PDF
         * @param {PoliciesApiExportPolicyVersionPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyVersionPdf(requestParameters: PoliciesApiExportPolicyVersionPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportPolicyVersionPdf(requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated acknowledgment progress for each published policy in the current organization.
         * @summary Get acknowledgment progress per policy
         * @param {PoliciesApiGetAcknowledgmentProgressPerPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAcknowledgmentProgressPerPolicy(requestParameters: PoliciesApiGetAcknowledgmentProgressPerPolicyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PolicyAcknowledgmentProgressPaginated> {
            return localVarFp.getAcknowledgmentProgressPerPolicy(requestParameters.page, requestParameters.size, requestParameters.nameOrUniqueCode, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated historical policy acknowledgments for the current user.
         * @summary Get historical acknowledgments
         * @param {PoliciesApiGetHistoricalAcknowledgmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricalAcknowledgments(requestParameters: PoliciesApiGetHistoricalAcknowledgmentsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PolicyAcknowledgmentExpandedPaginated> {
            return localVarFp.getHistoricalAcknowledgments(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.policyNameOrUniqueCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a policy by id with its display version.
         * @summary Get Policy
         * @param {PoliciesApiGetPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicy(requestParameters: PoliciesApiGetPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<Policy> {
            return localVarFp.getPolicy(requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get aggregated overview of policy acknowledgments for the current organization.
         * @summary Get acknowledgments overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyAcknowledgmentsOverview(options?: RawAxiosRequestConfig): AxiosPromise<PolicyAcknowledgmentOverview> {
            return localVarFp.getPolicyAcknowledgmentsOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Policy Comments
         * @param {PoliciesApiGetPolicyCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyComments(requestParameters: PoliciesApiGetPolicyCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>> {
            return localVarFp.getPolicyComments(requestParameters.policyId, requestParameters.excludePolicyVersions, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a signed URL to preview the PDF attached to the current policy.
         * @summary Get Policy Current URL PDF
         * @param {PoliciesApiGetPolicyContentFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyContentFile(requestParameters: PoliciesApiGetPolicyContentFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string | null; }> {
            return localVarFp.getPolicyContentFile(requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get activity logs for a policy.
         * @summary Get Policy Logs
         * @param {PoliciesApiGetPolicyLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyLogs(requestParameters: PoliciesApiGetPolicyLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Log>> {
            return localVarFp.getPolicyLogs(requestParameters.policyId, requestParameters.excludePolicyVersions, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific policy version by policy_id and policy_version_id.
         * @summary Get Policy Version
         * @param {PoliciesApiGetPolicyVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersion(requestParameters: PoliciesApiGetPolicyVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyVersion> {
            return localVarFp.getPolicyVersion(requestParameters.policyVersionId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Policy Version Comments
         * @param {PoliciesApiGetPolicyVersionCommentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersionComments(requestParameters: PoliciesApiGetPolicyVersionCommentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>> {
            return localVarFp.getPolicyVersionComments(requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a signed URL to preview the PDF attached to a policy version.
         * @summary Get Policy Version URL PDF
         * @param {PoliciesApiGetPolicyVersionContentFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersionContentFile(requestParameters: PoliciesApiGetPolicyVersionContentFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string | null; }> {
            return localVarFp.getPolicyVersionContentFile(requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Policy Version Frameworks
         * @param {PoliciesApiGetPolicyVersionFrameworksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersionFrameworks(requestParameters: PoliciesApiGetPolicyVersionFrameworksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlatformFramework>> {
            return localVarFp.getPolicyVersionFrameworks(requestParameters.policyVersionId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get audit logs for a specific policy version.
         * @summary Get Policy Version Logs
         * @param {PoliciesApiGetPolicyVersionLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersionLogs(requestParameters: PoliciesApiGetPolicyVersionLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Log>> {
            return localVarFp.getPolicyVersionLogs(requestParameters.policyVersionId, requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the template associated with the policy policy_template_version_id.
         * @summary Get Policy Template
         * @param {PoliciesApiGetTemplateUsedByPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUsedByPolicy(requestParameters: PoliciesApiGetTemplateUsedByPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplate> {
            return localVarFp.getTemplateUsedByPolicy(requestParameters.policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated acknowledgment progress for each active user in the current organization.
         * @summary Get acknowledgment progress per user
         * @param {PoliciesApiGetUserAcknowledgmentProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAcknowledgmentProgress(requestParameters: PoliciesApiGetUserAcknowledgmentProgressRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserAcknowledgmentProgressPaginated> {
            return localVarFp.getUserAcknowledgmentProgress(requestParameters.page, requestParameters.size, requestParameters.nameOrEmail, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * Query policies acknowledgments in the current organization. By default it filter acknowledgments of the latest published policies.
         * @summary Query acknowledgments
         * @param {PoliciesApiQueryAcknowledgeablePoliciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryAcknowledgeablePolicies(requestParameters: PoliciesApiQueryAcknowledgeablePoliciesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PolicyAcknowledgmentPaginated> {
            return localVarFp.queryAcknowledgeablePolicies(requestParameters.page, requestParameters.size, requestParameters.acknowledgedById, requestParameters.policyId, requestParameters.policyVersionId, requestParameters.includeHistoricAcknowledgments, options).then((request) => request(axios, basePath));
        },
        /**
         * Query policies for the current organization. Non-policy-managers can only see published policies.
         * @summary Query Policies
         * @param {PoliciesApiQueryPoliciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicies(requestParameters: PoliciesApiQueryPoliciesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PolicyPaginated> {
            return localVarFp.queryPolicies(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.status, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Query policies with nested published and draft versions.
         * @summary Query Policies Expanded
         * @param {PoliciesApiQueryPoliciesExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPoliciesExpanded(requestParameters: PoliciesApiQueryPoliciesExpandedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PolicyOverviewPaginated> {
            return localVarFp.queryPoliciesExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.assignedToId, requestParameters.draftPolicyVersionStatus, requestParameters.nameOrUniqueCode, requestParameters.status, requestParameters.exactMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of published policies (latest version) with acknowledgment status for a user.
         * @summary Get policy acknowledgments expanded
         * @param {PoliciesApiQueryPolicyAcknowledgmentsExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyAcknowledgmentsExpanded(requestParameters: PoliciesApiQueryPolicyAcknowledgmentsExpandedRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyAcknowledgmentExpandedPaginated> {
            return localVarFp.queryPolicyAcknowledgmentsExpanded(requestParameters.userId, requestParameters.page, requestParameters.size, requestParameters.policyNameOrUniqueCode, requestParameters.isAcknowledged, options).then((request) => request(axios, basePath));
        },
        /**
         * Query all versions of a specific policy.
         * @summary Query Policy Versions
         * @param {PoliciesApiQueryPolicyVersionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyVersions(requestParameters: PoliciesApiQueryPolicyVersionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyVersionPaginated> {
            return localVarFp.queryPolicyVersions(requestParameters.policyId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Framework from Policy Version
         * @param {PoliciesApiRemovePlatformFrameworkFromPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePlatformFrameworkFromPolicy(requestParameters: PoliciesApiRemovePlatformFrameworkFromPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyVersion> {
            return localVarFp.removePlatformFrameworkFromPolicy(requestParameters.platformFrameworkId, requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace All Frameworks of Policy Version
         * @param {PoliciesApiUpdatePlatformFrameworksInPolicyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlatformFrameworksInPolicy(requestParameters: PoliciesApiUpdatePlatformFrameworksInPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyVersion> {
            return localVarFp.updatePlatformFrameworksInPolicy(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.policyVersionFrameworksUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the owner of a policy.
         * @summary Update Policy Owner
         * @param {PoliciesApiUpdatePolicyOwnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyOwner(requestParameters: PoliciesApiUpdatePolicyOwnerRequest, options?: RawAxiosRequestConfig): AxiosPromise<Policy> {
            return localVarFp.updatePolicyOwner(requestParameters.policyId, requestParameters.policyOwnerUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a policy.
         * @summary Update Policy Status
         * @param {PoliciesApiUpdatePolicyStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyStatus(requestParameters: PoliciesApiUpdatePolicyStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Policy> {
            return localVarFp.updatePolicyStatus(requestParameters.policyId, requestParameters.policyStatusUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit name and content of a policy version.
         * @summary Update Policy Version
         * @param {PoliciesApiUpdatePolicyVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyVersion(requestParameters: PoliciesApiUpdatePolicyVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyVersion> {
            return localVarFp.updatePolicyVersion(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.policyVersionUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the status of a policy version.
         * @summary Update Policy Version Status
         * @param {PoliciesApiUpdatePolicyVersionStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyVersionStatus(requestParameters: PoliciesApiUpdatePolicyVersionStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyVersion> {
            return localVarFp.updatePolicyVersionStatus(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.policyVersionStatusUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a PDF file to an existing policy version. Replaces any previously attached file.
         * @summary Upload Policy Version PDF
         * @param {PoliciesApiUploadPolicyVersionFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPolicyVersionFile(requestParameters: PoliciesApiUploadPolicyVersionFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyVersion> {
            return localVarFp.uploadPolicyVersionFile(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.contentFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acknowledgePolicy operation in PoliciesApi.
 */
export interface PoliciesApiAcknowledgePolicyRequest {
    readonly policyId: string
}

/**
 * Request parameters for addPlatformFrameworkIntoPolicy operation in PoliciesApi.
 */
export interface PoliciesApiAddPlatformFrameworkIntoPolicyRequest {
    readonly policyId: string

    readonly policyVersionId: string

    readonly policyVersionFrameworkUpdate: PolicyVersionFrameworkUpdate
}

/**
 * Request parameters for createPolicy operation in PoliciesApi.
 */
export interface PoliciesApiCreatePolicyRequest {
    readonly policyCreate: PolicyCreate
}

/**
 * Request parameters for createPolicyComments operation in PoliciesApi.
 */
export interface PoliciesApiCreatePolicyCommentsRequest {
    readonly policyId: string

    readonly addCommentRequest: AddCommentRequest
}

/**
 * Request parameters for createPolicyVersion operation in PoliciesApi.
 */
export interface PoliciesApiCreatePolicyVersionRequest {
    readonly policyId: string

    readonly policyVersionCreate: PolicyVersionCreate
}

/**
 * Request parameters for createPolicyVersionComments operation in PoliciesApi.
 */
export interface PoliciesApiCreatePolicyVersionCommentsRequest {
    readonly policyId: string

    readonly policyVersionId: string

    readonly addCommentRequest: AddCommentRequest
}

/**
 * Request parameters for deletePolicyVersionContentFile operation in PoliciesApi.
 */
export interface PoliciesApiDeletePolicyVersionContentFileRequest {
    readonly policyId: string

    readonly policyVersionId: string
}

/**
 * Request parameters for exportPolicyVersionPdf operation in PoliciesApi.
 */
export interface PoliciesApiExportPolicyVersionPdfRequest {
    readonly policyId: string

    readonly policyVersionId: string
}

/**
 * Request parameters for getAcknowledgmentProgressPerPolicy operation in PoliciesApi.
 */
export interface PoliciesApiGetAcknowledgmentProgressPerPolicyRequest {
    readonly page?: number

    readonly size?: number

    readonly nameOrUniqueCode?: string | null

    readonly status?: PolicyAcknowledgmentStatus | null
}

/**
 * Request parameters for getHistoricalAcknowledgments operation in PoliciesApi.
 */
export interface PoliciesApiGetHistoricalAcknowledgmentsRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: HistoricalPolicyAcknowledgmentSorting | null

    readonly descending?: boolean | null

    readonly policyNameOrUniqueCode?: string | null
}

/**
 * Request parameters for getPolicy operation in PoliciesApi.
 */
export interface PoliciesApiGetPolicyRequest {
    readonly policyId: string
}

/**
 * Request parameters for getPolicyComments operation in PoliciesApi.
 */
export interface PoliciesApiGetPolicyCommentsRequest {
    readonly policyId: string

    readonly excludePolicyVersions?: boolean
}

/**
 * Request parameters for getPolicyContentFile operation in PoliciesApi.
 */
export interface PoliciesApiGetPolicyContentFileRequest {
    readonly policyId: string
}

/**
 * Request parameters for getPolicyLogs operation in PoliciesApi.
 */
export interface PoliciesApiGetPolicyLogsRequest {
    readonly policyId: string

    readonly excludePolicyVersions?: boolean
}

/**
 * Request parameters for getPolicyVersion operation in PoliciesApi.
 */
export interface PoliciesApiGetPolicyVersionRequest {
    readonly policyVersionId: string

    readonly policyId: string
}

/**
 * Request parameters for getPolicyVersionComments operation in PoliciesApi.
 */
export interface PoliciesApiGetPolicyVersionCommentsRequest {
    readonly policyId: string

    readonly policyVersionId: string
}

/**
 * Request parameters for getPolicyVersionContentFile operation in PoliciesApi.
 */
export interface PoliciesApiGetPolicyVersionContentFileRequest {
    readonly policyId: string

    readonly policyVersionId: string
}

/**
 * Request parameters for getPolicyVersionFrameworks operation in PoliciesApi.
 */
export interface PoliciesApiGetPolicyVersionFrameworksRequest {
    readonly policyVersionId: string

    readonly policyId: string
}

/**
 * Request parameters for getPolicyVersionLogs operation in PoliciesApi.
 */
export interface PoliciesApiGetPolicyVersionLogsRequest {
    readonly policyVersionId: string

    readonly policyId: string
}

/**
 * Request parameters for getTemplateUsedByPolicy operation in PoliciesApi.
 */
export interface PoliciesApiGetTemplateUsedByPolicyRequest {
    readonly policyId: string
}

/**
 * Request parameters for getUserAcknowledgmentProgress operation in PoliciesApi.
 */
export interface PoliciesApiGetUserAcknowledgmentProgressRequest {
    readonly page?: number

    readonly size?: number

    readonly nameOrEmail?: string | null

    readonly status?: UserAcknowledgmentStatus | null
}

/**
 * Request parameters for queryAcknowledgeablePolicies operation in PoliciesApi.
 */
export interface PoliciesApiQueryAcknowledgeablePoliciesRequest {
    readonly page?: number

    readonly size?: number

    readonly acknowledgedById?: string | null

    readonly policyId?: string | null

    readonly policyVersionId?: string | null

    readonly includeHistoricAcknowledgments?: boolean
}

/**
 * Request parameters for queryPolicies operation in PoliciesApi.
 */
export interface PoliciesApiQueryPoliciesRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: PolicySorting | null

    readonly descending?: boolean | null

    readonly nameOrUniqueCode?: string | null

    readonly status?: PolicyStatus | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for queryPoliciesExpanded operation in PoliciesApi.
 */
export interface PoliciesApiQueryPoliciesExpandedRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: PolicyExpandedSorting | null

    readonly descending?: boolean | null

    readonly assignedToId?: string | null

    readonly draftPolicyVersionStatus?: PolicyVersionStatus | null

    readonly nameOrUniqueCode?: string | null

    readonly status?: PolicyStatus | null

    readonly exactMatch?: boolean
}

/**
 * Request parameters for queryPolicyAcknowledgmentsExpanded operation in PoliciesApi.
 */
export interface PoliciesApiQueryPolicyAcknowledgmentsExpandedRequest {
    readonly userId: string

    readonly page?: number

    readonly size?: number

    readonly policyNameOrUniqueCode?: string | null

    readonly isAcknowledged?: boolean | null
}

/**
 * Request parameters for queryPolicyVersions operation in PoliciesApi.
 */
export interface PoliciesApiQueryPolicyVersionsRequest {
    readonly policyId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: PolicyVersionSorting | null

    readonly descending?: boolean | null

    readonly name?: string | null

    readonly status?: PolicyVersionStatus | null
}

/**
 * Request parameters for removePlatformFrameworkFromPolicy operation in PoliciesApi.
 */
export interface PoliciesApiRemovePlatformFrameworkFromPolicyRequest {
    readonly platformFrameworkId: string

    readonly policyId: string

    readonly policyVersionId: string
}

/**
 * Request parameters for updatePlatformFrameworksInPolicy operation in PoliciesApi.
 */
export interface PoliciesApiUpdatePlatformFrameworksInPolicyRequest {
    readonly policyId: string

    readonly policyVersionId: string

    readonly policyVersionFrameworksUpdate: PolicyVersionFrameworksUpdate
}

/**
 * Request parameters for updatePolicyOwner operation in PoliciesApi.
 */
export interface PoliciesApiUpdatePolicyOwnerRequest {
    readonly policyId: string

    readonly policyOwnerUpdate: PolicyOwnerUpdate
}

/**
 * Request parameters for updatePolicyStatus operation in PoliciesApi.
 */
export interface PoliciesApiUpdatePolicyStatusRequest {
    readonly policyId: string

    readonly policyStatusUpdate: PolicyStatusUpdate
}

/**
 * Request parameters for updatePolicyVersion operation in PoliciesApi.
 */
export interface PoliciesApiUpdatePolicyVersionRequest {
    readonly policyId: string

    readonly policyVersionId: string

    readonly policyVersionUpdate: PolicyVersionUpdate
}

/**
 * Request parameters for updatePolicyVersionStatus operation in PoliciesApi.
 */
export interface PoliciesApiUpdatePolicyVersionStatusRequest {
    readonly policyId: string

    readonly policyVersionId: string

    readonly policyVersionStatusUpdate: PolicyVersionStatusUpdate
}

/**
 * Request parameters for uploadPolicyVersionFile operation in PoliciesApi.
 */
export interface PoliciesApiUploadPolicyVersionFileRequest {
    readonly policyId: string

    readonly policyVersionId: string

    readonly contentFile: File
}

/**
 * PoliciesApi - object-oriented interface
 */
export class PoliciesApi extends BaseAPI {
    /**
     * Record that the current user has acknowledged the policy\'s published version.
     * @summary Acknowledge Policy
     * @param {PoliciesApiAcknowledgePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public acknowledgePolicy(requestParameters: PoliciesApiAcknowledgePolicyRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).acknowledgePolicy(requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add Framework to Policy Version
     * @param {PoliciesApiAddPlatformFrameworkIntoPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addPlatformFrameworkIntoPolicy(requestParameters: PoliciesApiAddPlatformFrameworkIntoPolicyRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).addPlatformFrameworkIntoPolicy(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.policyVersionFrameworkUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new policy for the organization
     * @summary Create Policy
     * @param {PoliciesApiCreatePolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPolicy(requestParameters: PoliciesApiCreatePolicyRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).createPolicy(requestParameters.policyCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Policy Comments
     * @param {PoliciesApiCreatePolicyCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPolicyComments(requestParameters: PoliciesApiCreatePolicyCommentsRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).createPolicyComments(requestParameters.policyId, requestParameters.addCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new version for an existing policy.
     * @summary Create Policy Version
     * @param {PoliciesApiCreatePolicyVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPolicyVersion(requestParameters: PoliciesApiCreatePolicyVersionRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).createPolicyVersion(requestParameters.policyId, requestParameters.policyVersionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Policy Version Comments
     * @param {PoliciesApiCreatePolicyVersionCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPolicyVersionComments(requestParameters: PoliciesApiCreatePolicyVersionCommentsRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).createPolicyVersionComments(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.addCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the PDF attached to a draft policy version.
     * @summary Delete Policy Version PDF
     * @param {PoliciesApiDeletePolicyVersionContentFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePolicyVersionContentFile(requestParameters: PoliciesApiDeletePolicyVersionContentFileRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).deletePolicyVersionContentFile(requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export the current display version of a policy as a PDF document.
     * @summary Export Policy PDF
     * @param {PoliciesApiExportPolicyVersionPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportPolicyVersionPdf(requestParameters: PoliciesApiExportPolicyVersionPdfRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).exportPolicyVersionPdf(requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated acknowledgment progress for each published policy in the current organization.
     * @summary Get acknowledgment progress per policy
     * @param {PoliciesApiGetAcknowledgmentProgressPerPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAcknowledgmentProgressPerPolicy(requestParameters: PoliciesApiGetAcknowledgmentProgressPerPolicyRequest = {}, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getAcknowledgmentProgressPerPolicy(requestParameters.page, requestParameters.size, requestParameters.nameOrUniqueCode, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated historical policy acknowledgments for the current user.
     * @summary Get historical acknowledgments
     * @param {PoliciesApiGetHistoricalAcknowledgmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHistoricalAcknowledgments(requestParameters: PoliciesApiGetHistoricalAcknowledgmentsRequest = {}, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getHistoricalAcknowledgments(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.policyNameOrUniqueCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a policy by id with its display version.
     * @summary Get Policy
     * @param {PoliciesApiGetPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicy(requestParameters: PoliciesApiGetPolicyRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicy(requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get aggregated overview of policy acknowledgments for the current organization.
     * @summary Get acknowledgments overview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyAcknowledgmentsOverview(options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicyAcknowledgmentsOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Policy Comments
     * @param {PoliciesApiGetPolicyCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyComments(requestParameters: PoliciesApiGetPolicyCommentsRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicyComments(requestParameters.policyId, requestParameters.excludePolicyVersions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a signed URL to preview the PDF attached to the current policy.
     * @summary Get Policy Current URL PDF
     * @param {PoliciesApiGetPolicyContentFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyContentFile(requestParameters: PoliciesApiGetPolicyContentFileRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicyContentFile(requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get activity logs for a policy.
     * @summary Get Policy Logs
     * @param {PoliciesApiGetPolicyLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyLogs(requestParameters: PoliciesApiGetPolicyLogsRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicyLogs(requestParameters.policyId, requestParameters.excludePolicyVersions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific policy version by policy_id and policy_version_id.
     * @summary Get Policy Version
     * @param {PoliciesApiGetPolicyVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyVersion(requestParameters: PoliciesApiGetPolicyVersionRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicyVersion(requestParameters.policyVersionId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Policy Version Comments
     * @param {PoliciesApiGetPolicyVersionCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyVersionComments(requestParameters: PoliciesApiGetPolicyVersionCommentsRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicyVersionComments(requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a signed URL to preview the PDF attached to a policy version.
     * @summary Get Policy Version URL PDF
     * @param {PoliciesApiGetPolicyVersionContentFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyVersionContentFile(requestParameters: PoliciesApiGetPolicyVersionContentFileRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicyVersionContentFile(requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Policy Version Frameworks
     * @param {PoliciesApiGetPolicyVersionFrameworksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyVersionFrameworks(requestParameters: PoliciesApiGetPolicyVersionFrameworksRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicyVersionFrameworks(requestParameters.policyVersionId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get audit logs for a specific policy version.
     * @summary Get Policy Version Logs
     * @param {PoliciesApiGetPolicyVersionLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyVersionLogs(requestParameters: PoliciesApiGetPolicyVersionLogsRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getPolicyVersionLogs(requestParameters.policyVersionId, requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the template associated with the policy policy_template_version_id.
     * @summary Get Policy Template
     * @param {PoliciesApiGetTemplateUsedByPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTemplateUsedByPolicy(requestParameters: PoliciesApiGetTemplateUsedByPolicyRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getTemplateUsedByPolicy(requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated acknowledgment progress for each active user in the current organization.
     * @summary Get acknowledgment progress per user
     * @param {PoliciesApiGetUserAcknowledgmentProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserAcknowledgmentProgress(requestParameters: PoliciesApiGetUserAcknowledgmentProgressRequest = {}, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).getUserAcknowledgmentProgress(requestParameters.page, requestParameters.size, requestParameters.nameOrEmail, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query policies acknowledgments in the current organization. By default it filter acknowledgments of the latest published policies.
     * @summary Query acknowledgments
     * @param {PoliciesApiQueryAcknowledgeablePoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryAcknowledgeablePolicies(requestParameters: PoliciesApiQueryAcknowledgeablePoliciesRequest = {}, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).queryAcknowledgeablePolicies(requestParameters.page, requestParameters.size, requestParameters.acknowledgedById, requestParameters.policyId, requestParameters.policyVersionId, requestParameters.includeHistoricAcknowledgments, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query policies for the current organization. Non-policy-managers can only see published policies.
     * @summary Query Policies
     * @param {PoliciesApiQueryPoliciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryPolicies(requestParameters: PoliciesApiQueryPoliciesRequest = {}, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).queryPolicies(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrUniqueCode, requestParameters.status, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query policies with nested published and draft versions.
     * @summary Query Policies Expanded
     * @param {PoliciesApiQueryPoliciesExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryPoliciesExpanded(requestParameters: PoliciesApiQueryPoliciesExpandedRequest = {}, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).queryPoliciesExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.assignedToId, requestParameters.draftPolicyVersionStatus, requestParameters.nameOrUniqueCode, requestParameters.status, requestParameters.exactMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of published policies (latest version) with acknowledgment status for a user.
     * @summary Get policy acknowledgments expanded
     * @param {PoliciesApiQueryPolicyAcknowledgmentsExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryPolicyAcknowledgmentsExpanded(requestParameters: PoliciesApiQueryPolicyAcknowledgmentsExpandedRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).queryPolicyAcknowledgmentsExpanded(requestParameters.userId, requestParameters.page, requestParameters.size, requestParameters.policyNameOrUniqueCode, requestParameters.isAcknowledged, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query all versions of a specific policy.
     * @summary Query Policy Versions
     * @param {PoliciesApiQueryPolicyVersionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryPolicyVersions(requestParameters: PoliciesApiQueryPolicyVersionsRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).queryPolicyVersions(requestParameters.policyId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.name, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Framework from Policy Version
     * @param {PoliciesApiRemovePlatformFrameworkFromPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removePlatformFrameworkFromPolicy(requestParameters: PoliciesApiRemovePlatformFrameworkFromPolicyRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).removePlatformFrameworkFromPolicy(requestParameters.platformFrameworkId, requestParameters.policyId, requestParameters.policyVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace All Frameworks of Policy Version
     * @param {PoliciesApiUpdatePlatformFrameworksInPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePlatformFrameworksInPolicy(requestParameters: PoliciesApiUpdatePlatformFrameworksInPolicyRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).updatePlatformFrameworksInPolicy(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.policyVersionFrameworksUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the owner of a policy.
     * @summary Update Policy Owner
     * @param {PoliciesApiUpdatePolicyOwnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePolicyOwner(requestParameters: PoliciesApiUpdatePolicyOwnerRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).updatePolicyOwner(requestParameters.policyId, requestParameters.policyOwnerUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a policy.
     * @summary Update Policy Status
     * @param {PoliciesApiUpdatePolicyStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePolicyStatus(requestParameters: PoliciesApiUpdatePolicyStatusRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).updatePolicyStatus(requestParameters.policyId, requestParameters.policyStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit name and content of a policy version.
     * @summary Update Policy Version
     * @param {PoliciesApiUpdatePolicyVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePolicyVersion(requestParameters: PoliciesApiUpdatePolicyVersionRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).updatePolicyVersion(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.policyVersionUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the status of a policy version.
     * @summary Update Policy Version Status
     * @param {PoliciesApiUpdatePolicyVersionStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePolicyVersionStatus(requestParameters: PoliciesApiUpdatePolicyVersionStatusRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).updatePolicyVersionStatus(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.policyVersionStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a PDF file to an existing policy version. Replaces any previously attached file.
     * @summary Upload Policy Version PDF
     * @param {PoliciesApiUploadPolicyVersionFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPolicyVersionFile(requestParameters: PoliciesApiUploadPolicyVersionFileRequest, options?: RawAxiosRequestConfig) {
        return PoliciesApiFp(this.configuration).uploadPolicyVersionFile(requestParameters.policyId, requestParameters.policyVersionId, requestParameters.contentFile, options).then((request) => request(this.axios, this.basePath));
    }
}

